import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-loading-wrapper',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class LoadingComponent implements OnInit {
    @Input() loading: boolean;

    constructor() {}

    ngOnInit(): void {}
}
